import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';

import SiteLayout from './SiteLayout';
import ScrollToTop from './ScrollToTop';
import BookingPage from '../pages/BookingPage';
import BookingConfirmationPage from '../pages/BookingConfirmationPage';
import ContactPage from '../pages/ContactPage';
import HomePage from '../pages/HomePage';
import LocationPage from '../pages/LocationPage';
import NotFoundPage from '../pages/NotFoundPage';
import ResidencePage from '../pages/ResidencePage';
import ResidencesPage from '../pages/ResidencesPage';
import SaleApartmentPage from '../pages/SaleApartmentPage';
import SalePage from '../pages/SalePage';

function App() {
  const Router = window.location.protocol === 'file:' ? HashRouter : BrowserRouter;

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="residences" element={<ResidencesPage />} />
          <Route path="residences/:residenceId" element={<ResidencePage />} />
          <Route path="sale" element={<SalePage />} />
          <Route path="sale/:apartmentNumber" element={<SaleApartmentPage />} />
          <Route path="location" element={<LocationPage />} />
          <Route path="book" element={<BookingPage />} />
          <Route path="book/confirm" element={<BookingConfirmationPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
